/**
 * 登录页跑酷小游戏 成绩接口（按登录账号记录到数据库）
 */
import request from './request'

/**
 * 保存一次跑酷成绩
 * @param {{userId?: number, no: string, score: number}} data
 */
export function saveGameScore(data) {
  return request.post('/gameScore/save', data)
}

/**
 * 查询账号的历史最高分
 * @param {string} no 登录账号
 */
export function getBestScore(no) {
  return request.get('/gameScore/best', { params: { no } })
}
